const Pages = () => import(/* webpackChunkName: "pages" */ '@/views/Pages')
const ManagePage = () => import(/* webpackChunkName: "manage-page" */ '@/views/ManagePage')

export default [
  {
    path: '/',
    name: 'Pages',
    component: Pages
  },
  {
    path: '/add-page',
    name: 'AddPage',
    component: ManagePage
  },
  {
    path: '/edit/:id',
    name: 'EditPage',
    component: ManagePage
  }
]
